import { SignIn } from '@clerk/clerk-react';

const ClerkSignIn = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      {/* Centered Sign In Form */}
      <div className="w-full max-w-md">
        <SignIn
          appearance={{
            elements: {
              rootBox: 'w-full',
              card: 'shadow-lg border border-gray-100 bg-white rounded-xl px-6 py-6',
              headerTitle: 'text-2xl font-semibold text-gray-900',
              headerSubtitle: 'text-gray-600 text-base',
              socialButtonsBlockButton:
                'border border-gray-300 hover:bg-gray-50 bg-white rounded-lg',
              socialButtonsBlockButtonText: 'font-medium text-gray-700',
              dividerLine: 'bg-gray-200',
              dividerText: 'text-gray-500 bg-gray-50 px-3',
              formFieldLabel: 'text-gray-700 font-medium text-sm',
              formFieldInput:
                'border border-gray-300 focus:border-[#52acfc] focus:ring-2 focus:ring-[#52acfc]/20 rounded-lg',
              formButtonPrimary: 'bg-gray-900 hover:bg-gray-800 text-white font-medium rounded-lg',
              footerActionLink: 'text-[#52acfc] hover:text-[#3d8fd4] font-medium text-sm',
              identityPreviewText: 'text-gray-700 text-sm',
              identityPreviewEditButtonIcon: 'text-[#52acfc]',
              formFieldAction: 'text-[#52acfc] hover:text-[#3d8fd4] text-sm',
              formResendCodeLink: 'text-[#52acfc] hover:text-[#3d8fd4] text-sm',
              otpCodeFieldInput: 'border-gray-300 focus:border-[#52acfc] h-9',
              formFieldInputShowPasswordButton: 'text-gray-500 hover:text-gray-700',
              backLink: 'text-gray-600 hover:text-gray-800 text-sm',
              badge: 'bg-[#52acfc] text-white',
              // Hide Clerk branding (paid plan feature)
              footer: 'hidden',
            },
          }}
          signUpUrl="/signup"
          afterSignInUrl="/dashboard"
        />
      </div>
    </div>
  );
};

export default ClerkSignIn;
